var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',_vm._l((_vm.notes),function(note,idx){return _c('v-col',{key:idx,staticClass:"d-flex flex-column",attrs:{"cols":"12","sm":"6","md":"4","lg":"3","xl":"2"}},[_c('NoteItem',{attrs:{"note":note}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }